// eslint-disable-next-line no-restricted-imports
import {
  PageLayoutEnum,
  SecondaryCtaColorSchemeEnum,
  SimpleStickyFooterColorSchemaEnum,
} from '__generated__/graphql';

/* eslint-disable no-restricted-imports */
export {
  SelectedProductsDisplayTypeEnum as EnumDisplayType,
  HeadingLevelEnum as EnumHeadingLevel,
  CampaingColorEnum as EnumCampaingColor,
  OrderTableItemComponentColumnEnum as EnumOrderTableItemComponentColumn,
  SwiperCardsBannerColorSchemeEnum as Enum_Componentpagescomponentswipercardsbanner_Color_Scheme,
  PageRelevantArticleTypeEnum as EnumTypeReleventArticle,
  RelevantArticleModeEnum as EnumRelevantArticleMode,
  CallToActionColorSchemeEnum as EnumColorSchema,
  PageLayoutEnum as Page_Layout,
  HeaderWithTabsTabIconEnum as Enum_Componentpagescomponentheaderwithtabstab_Icon,
  IconEnum as EnumIcon,
  // EnumPrefix,
  // EnumTracking,
  HeadingLevelEnum as EnumHeading,
  TabTargetEnum as EnumLinkTarget,
  SummaryProductsListTypeEnum as EnumSummaryProductsListType,
  StandoutTextBlockTypeEnum as EnumStandoutTextBlockType,
  TabTargetEnum as EnumTabTarget,
  SectionalHeaderComponentLevelEnum as EnumSectionalHeaderComponentLevel,
  FlexibleHeroBlockRewardTypeEnum as EnumFlexibleHeroBlockRewardType,
  FlexibleHeroBlockThemeEnum as EnumFlexibleHeroBlockTheme,
  FlexibleHeroBlockTextAlignEnum as EnumFlexibleHeroBlockTextAlign,
  CallToActionColorSchemeEnum as EnumCallToActionColorScheme,
  TravelPolicySearchTripTypeEnum,
  CarInsuranceProductComponentButtonTypeEnum,
  FlexibleHeroBlockHeroTypeEnum as EnumFlexibleHeroBlockHeroType,
  CtaButtonStyleTypeEnum as EnumCtaButtonStyleType,
  CtaButtonVariantEnum as EnumCtaButtonVariant,
  GridModuleAlignEnum as EnumGridModuleAlign,
  GridModuleBackgroundColorEnum as EnumGridModuleBackgroundColor,
  GridModuleWidthModeEnum as EnumGridModuleWidthMode,
  CustomerReviewsBlockAlignEnum as EnumCustomerReviewsBlockAlign,
  CustomerReviewsBlockBgColorVariantEnum as EnumCustomerReviewsBlockBgColorVariant,
  CustomerReviewsBlockReviewSourceEnum as EnumCustomerReviewsBlockReviewSource,
  VideoBlockAspectRatioEnum as EnumVideoBlockAspectRatio,
  VideoBlockEmbedTypeEnum as EnumVideoBlockEmbedType,
  ImageWidthEnum as EnumImageWidth,
  ImageAlignmentEnum as EnumImageAlignment,
  CtaSectionBlockBackgroundThemeEnum as EnumCtaSectionBlockBackgroundTheme,
  CtaSectionBlockTextAlignEnum as EnumCtaSectionBlockTextAlign,
  MiniProductHighlightBadgeColorEnum as EnumMiniProductHighlightBadgeColor,
  TestimonialsBackgroundColorEnum as EnumTestimonialsBackgroundColor,
} from '__generated__/graphql.enums';

export type { InsureMoRegion as TravelInsuranceRegion } from '__generated__/graphql';

export type CmsPageLayout = PageLayoutEnum;

export type StickyFooterSimpleColorSchema = SimpleStickyFooterColorSchemaEnum;

export type SecondaryCtaColorScheme = SecondaryCtaColorSchemeEnum;

// enums from cms-components
export {
  EnumHeadingTextBlock,
  EnumProductBlockColorTag,
  EnumRelevantArticleType,
  EnumRelevantArticleGroupType,
  type FaqBackgroundColor,
  type TravelInsuranceType,
  UrlPrefixEnum,
  type CurrencyPrefixType,
  UrlTargetEnum as UrlTargetType,
} from '@hyphengroup/cms-components/types/cmsEnums';

export { NavigationItemTypeEnum as NavigationItemType } from '@hyphengroup/cms-components/cms-blocks/navigation/types';
